export class ArrayUtils {
  static findDifference<T>(arr1: T[], arr2: T[]): T[] {
    if (Array.isArray(arr1) && Array.isArray(arr2)) {
      return arr1
        .filter((x) => !arr2.includes(x))
        .concat(arr2.filter((x) => !arr1.includes(x)));
    }
    return [];

  }

  static groupBy = (items: any[], key: string) => items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [
        ...(result[item[key]] || []),
        item,
      ],
    }), 
    {},
  );

  static getGroupedRowsCount(rows: any[], groupedColumn: string) {
    const groupedRows = this.groupBy(rows, groupedColumn);
    return Object.keys(groupedRows).length;
  }
}
